export default "__VITE_ASSET__DFJXq8Rq__"